<template>
    <div>
        <div v-if="showForm && !loading" class="row">
            <div style="width:100%;margin:0px auto;border: 1px solid; margin-top:6px;margin-bottom:10px;padding:5px;">
                <form @submit.prevent="submitForm" enctype="multipart/form-data"
                      class="cash-receipt-form container-fluid">
                    <div class="row">
                        <!-- Payment Application -->
                        <div class="col-md-3 mb-3">
                            <div class="card">
                                <div class="card-header" style="border-bottom: 2px solid">Payment Application</div>
                                <div class="card-body">
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label>Amount</label>
                                            <input v-model="form.amount" type="text"
                                                   @input="syncSingleInvoiceAmount"
                                                   class="form-control form-control-sm">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label>Date</label>
                                            <input v-model="form.date_payment" type="date"
                                                   class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Customer Payment Information -->
                        <div class="col-md-6 mb-3">
                            <div class="card">
                                <div class="card-header" style="border-bottom: 2px solid">Customer Payment Information
                                </div>
                                <div class="card-body">
                                    <div class="form-row">
                                        <div class="form-group col-md-4">
                                            <label>Type</label>
                                            <select v-model="form.type" class="form-control form-control-sm">
                                                <option value="">Select..</option>
                                                <option value="Cash">Cash</option>
                                                <option value="Check">Check</option>
                                                <option value="ACH">ACH</option>
                                                <option value="CC-Amex">CC-Amex</option>
                                                <option value="CC-V/MC">CC-V/MC</option>
                                                <option value="CC-DC">CC-DC</option>
                                                <option value="Misc Adj.">Misc Adj.</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label>Number</label>
                                            <input v-model="form.number" type="text"
                                                   class="form-control form-control-sm">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label>Date</label>
                                            <input v-model="form.date" type="date" class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Notes -->
                        <div class="col-md-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="form-group ">
                                        <label>Notes</label>
                                        <textarea v-model="form.notes" rows="3" class="form-control"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mb-3">
                            <div class="card">
                                <div class="card-header">Upload Documents</div>
                                <div class="card-body">
                                    <div id="file_form">
                                        <div id="upload_status" style="display: inline-block; opacity: 1"></div>
                                        <input type="file" class="form-control" @change="addDoc"
                                               style="opacity: 1; position: relative; width: 100%; height: auto"
                                               id="doc_upload"
                                               name="docs">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Submit -->
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary" :disabled="isSubmitting">{{ isSubmitting ? 'Saving...' : 'Apply Payment >' }}</button>
                        </div>
                    </div>

                </form>
            </div>
            <div class="col-12 mb-3">
                <div class="table-responsive">
                    <table class="table-rams1" style="width: 100%">
                        <thead>
                        <tr>
                            <th>Payment Application</th>
                            <th>Invoice</th>
                            <th>Billing Acc#</th>
                            <th>Billing Name</th>
                            <th>Billing Address</th>
                            <th class="text-right">Charges</th>
                            <th class="text-right">Sales Tax</th>
                            <th class="text-right">Total Due</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="4"></td>
                            <td class="text-right"><strong>Total:</strong></td>
                            <td class="text-right">{{formatMoney(totals.total_charge_due)}}</td>
                            <td class="text-right">{{formatMoney(totals.sales_tax)}}</td>
                            <td class="text-right">{{formatMoney(totals.total_due)}}</td>
                        </tr>
                        <tr v-for="(row, index) in form.invoices" :key="index">
                            <td class="d-flex">
                                <div class="form-inline">
                                    <div class="custom-control custom-checkbox mr-2">
                                        <input type="checkbox" v-model="row.checked"
                                               @change="validateTotal" class="custom-control-input"
                                               :id="'check'+index">
                                        <label class="custom-control-label"
                                               :for="'check'+index"></label>
                                    </div>
                                    <input v-model="row.amount" @input="validateTotal" type="text"
                                           class="form-control form-control-sm"
                                           style="width:80px">
                                </div>
                                <button v-if="!row.isNew && !row.hasAddedNew" @click="addNewInvoice(index)"
                                        type="button" style="font-size: 1.5em" class="btn btn-link p-0 text-success"
                                        :disabled="row.hasAddedNew">
                                    <b>+</b>
                                </button>
                            </td>
                            <td>
                                <select v-if="row.isNew" v-model="row.invoice_type" class="form-control form-control-sm">
                                    <option value="">Select...</option>
                                    <option value="adjustment">Adjustment</option>
                                    <option value="account">Account</option>
                                </select>
                                <a v-else :href="`/billings/show-invoice/${row.invoice_id}`" target="_blank">{{ row.invoice_id }}</a>
                            </td>
                            <td>{{ row.billing_acc }}</td>
                            <td>{{ row.billing_name }}</td>
                            <td>{{ row.billing_address }}</td>
                            <td class="text-right">{{ formatMoney(row.charges) }}</td>
                            <td class="text-right">{{ formatMoney(row.sales_tax) }}</td>
                            <td class="text-right">{{ formatMoney(row.total_due) }}</td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="loading" id="BILL_REPORT_RESULTS">
            <center><br><br><br><br><b style="font-size:16px;">Please wait a second. Data
                updating...</b><br><br><br><br></center>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CashReceiptForm',
    props: {
        isForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                amount: '',
                date_payment: new Date().toISOString().substr(0, 10),
                type: '',
                number: '',
                date: '',
                notes: '',
                docs: [],
                invoices: []
            },
            totals: {
                total_charge_due: 0,
                sales_tax: 0,
                total_due: 0
            },
            showForm: false,
            loading: false,
            isSubmitting: false
        };
    },
    mounted() {
        this.checkQueryParams();
        this.checkForEdit();
    },
    methods: {
        checkQueryParams() {
            const params = ['billing_account_id', 'client_company_id', 'customer_po_id', 'ticket_number', 'invoice_id'];
            const urlParams = new URLSearchParams(window.location.search);
            const hasQueryParam = params.some(param => urlParams.has(param));

            if (hasQueryParam) {
                this.showForm = true;
                this.getInvoices();
            }
        },
        checkForEdit() {
            const path = window.location.pathname;
            const editMatch = path.match(/\/cash_receipts\/(\d+)\/edit$/);
            if (editMatch) {
                this.editCashReceipt(editMatch[1]);
            }
        },
        addNewInvoice(index) {
            const originalInvoice = this.form.invoices[index];
            const newInvoice = {
                checked: false,
                invoice_id: '',
                invoice_type: '',
                original_invoice_id: originalInvoice.invoice_id,
                billing_acc: '',
                billing_name: '',
                billing_address: '',
                charges: 0,
                sales_tax: 0,
                total_due: 0,
                amount: null,
                isNew: true
            };
            this.form.invoices.splice(index + 1, 0, newInvoice);
            this.$set(this.form.invoices[index], 'hasAddedNew', true);
        },
        addDoc(event) {
            let container = document.getElementById('upload_status');
            if (!this.form.docs || !Array.isArray(this.form.docs)) {
                this.$set(this.form, 'docs', []);
            }
            uploadDoc(
                'doc_upload',
                '/upload-generic',
                (msg) => {
                    if (msg.success) {
                        msg.files.forEach(file => {
                            const div = document.createElement('div');
                            div.classList.add('note_file', 'd-flex', 'align-items-center');
                            div.style.margin = '1px';
                            div.innerHTML = `<a href="${file.url}" target="_blank">
                                    📎 <span style="margin-left:5px;">${file.filename}</span>
                                    <input type="hidden" name="fu_files[]" value="${file.path}"></a>
                                    <a href="#" onclick="this.parentElement.remove();return false;" style="color:#f00;margin-left:10px;">x</a>
                                `;
                            container.before(div);
                            this.form.docs.push(file.path);

                        });
                    } else {
                        alert('Upload error');
                    }
                },
                (err) => alert('Erro no upload: ' + err.message)
            );
            event.target.value = '';
        },
        removeDoc(index) {
            this.form.docs.splice(index, 1);
        },
        renderExistingDocs() {
            const container = document.getElementById('upload_status');
            container.innerHTML = ''; // Clear existing
            this.form.docs.forEach((path, index) => {
                const filename = path.split('/').pop();
                const url = path.replace('storage/', 'files/')
                const div = document.createElement('div');
                div.classList.add('note_file', 'd-flex', 'align-items-center');
                div.style.margin = '1px';
                div.innerHTML = `<a href="${url}" target="_blank">
                        📎 <span style="margin-left:5px;">${filename}</span>
                        <input type="hidden" name="fu_files[]" value="${path}"></a>
                        <a href="#" onclick="this.parentElement.remove();return false;" style="color:#f00;margin-left:10px;">x</a>
                    `;
                container.appendChild(div);
            });
        },
        submitForm() {
            this.isSubmitting = true;
            const processedInvoices = this.form.invoices.map(invoice => {
                if (!invoice.checked) {
                    return invoice;
                }

                if (invoice.isNew) {
                    const amount = parseFloat(invoice.amount) || 0;

                    // Se o valor for negativo, usa o ID negativo da invoice original
                    if (amount < 0 && invoice.original_invoice_id) {
                        return {
                            ...invoice,
                            invoice_id: -Math.abs(invoice.original_invoice_id)
                        };
                    }
                    return {
                        ...invoice,
                        invoice_id: null // Será criada uma nova invoice no backend
                    };
                }

                return invoice;
            });

            // Collect fu_files[] values from hidden inputs
            const fuFiles = [];
            document.querySelectorAll('input[name="fu_files[]"]').forEach(input => {
                if (input.value.trim()) {
                    fuFiles.push(input.value.trim());
                }
            });


            const url = this.form.id ? `/cash_receipts/${this.form.id}` : `/cash_receipts`;
            const method = this.form.id ? 'put' : 'post';

            const formData = {
                ...this.form,
                invoices: processedInvoices,
                fu_files: fuFiles,
                _method: method
            };
            axios.post(url, formData)
                .then(response => {

                    showMessage('s','Cash receipt saved successfully');
                    setTimeout(() => {
                        this.forceCloseWindow();
                    }, 500);
                })
                .catch(error => {
                    console.error('Error fetching cash receipt:', error);
                    const responseMessage = error?.response?.data?.message;
                    const responseErrors = error?.response?.data?.errors;
                    let errorMessage = 'Error saving cash receipt data';
                    if (responseMessage) {
                        errorMessage = responseMessage;
                    } else if (responseErrors && typeof responseErrors === 'object') {
                        const firstKey = Object.keys(responseErrors)[0];
                        const firstError = responseErrors[firstKey];
                        if (Array.isArray(firstError) && firstError[0]) {
                            errorMessage = firstError[0];
                        }
                    }
                    showMessage('e', errorMessage);
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        },
        forceCloseWindow() {
            // Try the common browser-compatible close strategies.
            window.open('', '_self');
            window.close();

            // Fallback when browser blocks close for non-script-opened tabs.
            setTimeout(() => {
                if (!window.closed) {
                    window.location.href = '/';
                }
            }, 200);
        },
        formatMoney(value) {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                return '$0.00';
            }
            const numValue = Number(value);
            if (isNaN(numValue)) {
                return '$0.00';
            }
            return `$${numValue.toFixed(2)}`;
        },
        editCashReceipt(id) {
            let app  = this;
            axios.get(`/cash_receipts/${id}`)
                .then(response => {
                    const data = response.data.data;
                    this.form = {
                        id: data.id,
                        amount: data.amount,
                        date_payment: data.date_payment,
                        type: data.type,
                        number: data.number,
                        date: data.date,
                        notes: data.notes,
                        docs: Array.isArray(data.documents) ? data.documents : [],
                        invoices: data.invoices
                    };


                    this.showForm = true;
                    setTimeout(function (){
                        app.renderExistingDocs();
                    },500);
                })
                .catch(error => {
                    console.error(error);
                    alert('Error loading cash receipt data');
                });
        },
        getInvoices() {
            this.loading = true;
            let app = this;
            axios.get(`/cash_receipts/invoices${window.location.search}`)
                .then(response => {
                    const data = response.data || {};
                    const incomingForm = data.form || {};
                    this.form = {
                        ...this.form,
                        ...incomingForm,
                        docs: Array.isArray(incomingForm.docs) ? incomingForm.docs : this.form.docs,
                        invoices: Array.isArray(incomingForm.invoices) ? incomingForm.invoices : this.form.invoices
                    };
                    if (!this.form.docs || !Array.isArray(this.form.docs)) {
                        this.$set(this.form, 'docs', []);
                    }
                    this.totals = {
                        total_charge_due: Number(data.totals && data.totals.total_charge_due) || 0,
                        sales_tax: Number(data.totals && data.totals.sales_tax) || 0,
                        total_due: Number(data.totals && data.totals.total_due) || 0
                    };
                    this.$nextTick(() => {
                        this.validateTotal();
                        this.renderExistingDocs();
                    });
                    app.loading = false;

                })
                .catch(error => {
                    app.loading = false;
                    console.error('Error fetching cash receipt:', error);
                    alert('Error loading cash receipt data');
                });
        },
        syncSingleInvoiceAmount() {
            const checkedInvoices = this.form.invoices.filter(invoice => invoice.checked);
            if (checkedInvoices.length !== 1) {
                return;
            }
            const amount = parseFloat(this.form.amount);
            checkedInvoices[0].amount = !isNaN(amount) ? amount : null;
        },
        validateTotal() {
            let totalAmount = 0;
            this.form.invoices.forEach(invoice => {
                if (invoice.checked) {
                    if (!invoice.amount) {
                        invoice.amount = invoice.total_due;
                    }
                    const amount = parseFloat(invoice.amount);
                    if (!isNaN(amount)) {
                        totalAmount += amount;
                    }
                } else {
                    invoice.amount = null;
                }
            });

            this.form.amount = totalAmount ? Math.round(totalAmount * 100) / 100 : 0;
        }
    }
};
</script>
